import { BffApiClient } from '@/common/services/api/bffClient';
import { wardMenuModulesEndpoint } from '../endpoints/menuModulesEndpoint';
import { MenuModulePayloadModel, MenuModuleModel } from '../types/menuTypes';

export class WardMenuModuleService {
  private static api = BffApiClient.getInstance();

  static async getModules(): Promise<MenuModuleModel[]> {
    const response = await this.api.get(`${wardMenuModulesEndpoint.getModules}`);
    return response.data as MenuModuleModel[];
  }

  static async getModulesIds(ids: number[]): Promise<MenuModuleModel[]> {
    const response = await this.api.get(`${wardMenuModulesEndpoint.getModulesIds(ids)}`);
    return response.data as MenuModuleModel[];
  }

  static async getModuleById(id: number): Promise<MenuModuleModel> {
    const response = await this.api.get(`${wardMenuModulesEndpoint.getModuleById(id)}`);
    return response.data as MenuModuleModel;
  }

  static async createModule(moduleData: MenuModulePayloadModel): Promise<MenuModuleModel> {
    const response = await this.api.post(`${wardMenuModulesEndpoint.createModule}`, moduleData);
    return response.data as MenuModuleModel;
  }

  static async updateModule(moduleData: MenuModuleModel): Promise<MenuModuleModel> {
    const response = await this.api.put(
      `${wardMenuModulesEndpoint.updateModule(moduleData.id)}`,
      moduleData
    );
    return response.data as MenuModuleModel;
  }

  static async deleteModule(id: number): Promise<void> {
    await this.api.delete(`${wardMenuModulesEndpoint.deleteModule(id)}`);
  }
}
